import { createSelector } from 'reselect';
import { permissionsSelector } from 'app/UserInfo/selectors';

import { parentFolderDetailsSelector } from 'app/Tree/selectors';
import ability from '../ability';
import { edit } from '../const';

export default createSelector(
  parentFolderDetailsSelector,
  permissionsSelector,
  (folder, permissions) =>
    ability.can({
      edit,
      folder,
      permissions
    })
);
